import { Grid, Typography, Stack } from "@mui/material";
import CountryOrCryptoFlag from "src/components/common/CountryOrCryptoFlag";
import { HoldingsListStyles } from "../common/styles/HoldingsList.styles";
import formatCoinName from "src/utils/formatCoinName";
import { RowDataType } from "src/pages/Addresses";
import { useState } from "react";
import CopySnackbar from "src/components/common/CopySnackbar";
import AddressActionButton from "./AddressActionButton";

type AddressListProps = {
  handleRowClick: (el: RowDataType) => void;
  data: RowDataType[];
};

const AddressList = (props: AddressListProps) => {
  const { data, handleRowClick } = props;
  const classes = HoldingsListStyles();

  const [copy, setCopy] = useState(false);

  const formatAddress = (address: string): string => {
    const splitStartAddress = address.slice(0, 6);
    const splitEndAddress = address.slice(-6);
    return `${splitStartAddress}...${splitEndAddress}`;
  };

  // Remove some coin formats that include (------)
  const formatCoinFormat = (name: string): string => {
    return name.replace(/\(.*?\)/g, "").trim();
  };

  return (
    <>
      <Grid container>
        {data.map((el, idx) => (
          <Grid
            key={`${el.name}-${idx}`}
            item
            xs={12}
            my={1}
            data-code={el.logoUrl}
            data-name={el.name}
            data-address={el.address}
            data-icon={el?.logoUrl}
            data-memo={el.memo}
            data-format={el.format}
            data-depositable={el.depositable}
            onClick={() => handleRowClick(el)}>
            <Grid container className={classes.listContainer}>
              <Grid item xs={2} className={classes.icon}>
                <CountryOrCryptoFlag name={el?.logoUrl} size={40} />
              </Grid>
              <Grid item xs={10} container>
                <Grid item xs={6}>
                  <Typography className={classes.title} style={{ fontSize: 16 }}>
                    {formatCoinName(el.name)}
                  </Typography>
                  <Typography className={classes.address}>{formatAddress(el.address)}</Typography>
                  {el.memo && <Typography>{el.memo}</Typography>}
                </Grid>
                <Grid item xs={3} container alignItems="center">
                  <Stack>
                    <Typography className={classes.format}>
                      {formatCoinFormat(el.format)}
                    </Typography>
                    <Typography sx={{ fontSize: "14px" }}>{el.status}</Typography>
                  </Stack>
                </Grid>
                <Grid item xs={3} container alignItems="center" justifyContent="flex-end">
                  <AddressActionButton el={el} handleRowClick={handleRowClick} setCopy={setCopy} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>

      <CopySnackbar open={copy} handleClose={setCopy} />
    </>
  );
};

export default AddressList;
